import {
  UPDATE_USER_INFO,
  UPDATE_USER_TOKEN,
} from '../constants/user';
import { cacheKeys } from '../constants/storageKeys';

const initState = {
  userInfo: {},
  userTokenInfo: {},
};

const user = (state = initState, action = {}) => {
  switch (action.type) {
    case UPDATE_USER_INFO:
      localStorage.setItem(cacheKeys.USER_INFO, JSON.stringify(action.userInfo));
      return { ...state, userInfo: action.userInfo };
    case UPDATE_USER_TOKEN:
      return { ...state, userTokenInfo: action.userToken };
    default:
      return state;
  }
};

export default user;
